<template>
  <div class="support-card">
    <NuxtImg
      loading="lazy"
      :src="supportImage"
      alt="support"
      class="w-full h-[200px] md:h-auto rounded-[10px] object-cover max-md:mb-2.5"
    />
    <div
      class="rounded-[10px] px-[30px] md:px-[40px] py-[30px] text-white relative"
      :class="blurryBackground ? 'bg-primary-1-darker' : 'bg-primary-2-darker'"
    >
      <div v-if="blurryBackground" class="shadow-box-1 max-md:hidden z-10" />
      <div class="text-mobile-heading-2 md:text-heading-2 mb-1 z-20 relative">
        <span class="mr-1">{{ t("index.howCanWe") }}</span>
        <span
          :class="type == 2 ? 'text-primary-1-lighter' : 'text-primary-2'"
          >{{ t("index.helpYou") }}</span
        >
      </div>
      <div class="text-mobile-heading-3 md:text-heading-3 mb-4 z-20 relative">
        {{ t("index.getSupport") }}
      </div>
      <div
        class="text-mobile-heading-6 md:text-heading-6"
        :class="{ 'md:mb-6': !blurryBackground }"
      >
        {{ t("index.supportDescription") }}
      </div>
      <ul
        class="text-mobile-heading-6 md:text-heading-6"
        v-if="$te('index.supportDescriptionItemOne')"
      >
        <li v-if="$te('index.supportDescriptionItemOne')">
          - {{ t("index.supportDescriptionItemOne") }}
        </li>
        <li v-if="$te('index.supportDescriptionItemTwo')">
          - {{ t("index.supportDescriptionItemTwo") }}
        </li>
        <li v-if="$te('index.supportDescriptionItemThree')">
          - {{ t("index.supportDescriptionItemThree") }}
        </li>
        <li v-if="$te('index.supportDescriptionItemFour')">
          - {{ t("index.supportDescriptionItemFour") }}
        </li>
      </ul>
      <div
        class="max-md:mt-3"
        :class="{ 'md:absolute md:bottom-7': blurryBackground }"
      >
        <a
          v-if="info?.whatsapp_number"
          class="info"
          :href="`https://wa.me/${replaceSpace(info?.whatsapp_number)}`"
          target="_blank"
        >
          <icon-whatsapp
            :class="type == 2 ? 'text-primary-1-lighter' : 'text-primary-2'"
          />
          <span dir="ltr">{{ info?.whatsapp_number }}</span>
        </a>
        <div v-if="info?.telephones && info?.telephones?.length" class="info">
          <icon-call
            :class="type == 2 ? 'text-primary-1-lighter' : 'text-primary-2'"
          />
          <a
            v-for="item in info?.telephones"
            :key="item"
            class="ltr:mr-3 rtl:ml-3"
            dir="ltr"
            :tel="item"
            :href="`tel:${item}`"
          >
            {{ item }}
          </a>
        </div>
        <a v-if="info?.email" class="info" :href="`mailto:${info?.email}`">
          <icon-email
            :class="type == 2 ? 'text-primary-1-lighter' : 'text-primary-2'"
          />
          <span class="underline">{{ info?.email }}</span>
        </a>
        <a
          v-if="showAddress && info?.address.address_description"
          class="info !items-start"
        >
          <icon-location-underline class="" />
          <p class="flex-1">{{ info?.address.address_description }}</p>
        </a>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
import type { ICompanyInfo } from "../../../types/general";
import { useAsyncData } from "nuxt/app";
const { t } = useI18n();
const config = useRuntimeConfig();

const props = defineProps({
  blurryBackground: { type: Boolean, default: true },
  showAddress: { type: Boolean, default: false },
  img: {
    type: String,
    default:
      "https://turpal-web.fra1.cdn.digitaloceanspaces.com/assets/direction/support.webp",
  },
  type: {
    type: Number,
    default: 1,
  },
});
const locale = useCookie("locale").value;
const { data: info } = await useAsyncData<ICompanyInfo | null>(
  `about-${locale}`,
  () => customFetch(`api/company-info?lang=${locale}`)
);

const supportImageSrc = (config.public.statics as any)?.supportImgSrc || null;

const supportImage = computed(() => {
  return supportImageSrc ? supportImageSrc : props.img;
});

function replaceSpace(item) {
  if (!item) return "";
  return item.replace(/\s+/g, "");
}
</script>
<style scoped>
.support-card {
  @apply md:grid grid-cols-2 gap-5 overflow-hidden items-stretch;
  .info {
    @apply mb-2.5 flex items-center block text-mobile-paragraph-1 md:text-paragraph-1 flex-wrap;
    svg {
      @apply text-[20px]  ltr:mr-2 rtl:ml-2;
    }
  }
}

.shadow-box-1 {
  position: absolute;
  top: 5%;
  left: 3%;
  width: 90px;
  height: 90px;
  border-radius: 100%;
  background: var(--primary-2-darker);
  filter: blur(30px) drop-shadow(0 0 10px var(--primary-2));
  opacity: 0.25;
}
</style>
